import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

// Confirmation shown when the user picks a different Gem while the current
// conversation already has messages. A Gem is bound to a conversation at
// creation (its system prompt resolves off `conversation.gemId`), so switching
// Gems mid-thread starts a fresh conversation rather than mutating this one.

interface GemSwitchDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function GemSwitchDialog({ open, onConfirm, onCancel }: GemSwitchDialogProps) {
  const { t } = useTranslation('chat');

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      slotProps={{
        paper: { sx: { borderRadius: (t) => `${t.shape.borderRadius}px`, maxWidth: 380 } },
      }}
    >
      <DialogTitle sx={{ fontSize: 16, fontWeight: 600 }}>
        {t('gemSwitchDialog.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 14 }}>
          {t('gemSwitchDialog.body')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} sx={{ color: 'text.secondary' }}>
          {t('gemSwitchDialog.cancel')}
        </Button>
        <Button onClick={onConfirm} variant="contained">
          {t('gemSwitchDialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
